const mutations = {
  updateZonaWaktu: (state, zona) => (state.zonaWaktu = zona),
  updateWaktu: (state, waktu) => (state.waktuSaatIni = waktu)
}

export default mutations
